"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.presets = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _LocalizationProvider = _interopRequireDefault(require("@mui/lab/LocalizationProvider"));

var _AdapterMoment = _interopRequireDefault(require("@mui/lab/AdapterMoment"));

var _utils = require("@alycecom/utils");

var _userTrackGiftSchedule = require("./userTrackGiftSchedule");

var nextMonday = (0, _momentTimezone.default)().tz('US/Eastern').day('Monday').day() + ((0, _momentTimezone.default)().day() >= 1 ? 7 : 0);
var presets = [{
  name: 'Tomorrow morning',
  time: (0, _momentTimezone.default)().tz('US/Eastern').add(1, 'day').set({
    hours: 10,
    minutes: 0,
    seconds: 0
  })
}, {
  name: 'Tomorrow afternoon',
  time: (0, _momentTimezone.default)().tz('US/Eastern').add(1, 'day').set({
    hours: 13,
    minutes: 0,
    seconds: 0
  })
}, {
  name: 'Monday morning',
  time: (0, _momentTimezone.default)().tz('US/Eastern').day(nextMonday).set({
    hours: 10,
    minutes: 0,
    seconds: 0
  })
}];
exports.presets = presets;
var presetTimezone = {
  EDT: 'Eastern Daylight Time',
  EST: 'Eastern Standard Time'
}[presets[0].time.format('z')];
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      zIndex = _ref.zIndex,
      palette = _ref.palette;
  return {
    popper: {
      width: 372,
      zIndex: zIndex.modal
    },
    menuList: {
      padding: 0
    },
    menuItem: {
      padding: spacing(1.5, 3)
    },
    menuItemCustom: {
      borderTop: "1px solid ".concat(palette.divider),
      height: '61px',
      justifyContent: 'center'
    },
    paper: {
      position: 'relative',
      '&:after': {
        width: 0,
        height: 0,
        margin: 'auto',
        content: '""',
        display: 'block',
        borderStyle: 'solid',
        borderColor: "#fff #0000 #0000 #0000",
        borderWidth: '12px 12px 0 12px',
        position: 'absolute',
        right: "36px",
        bottom: "-12px"
      }
    }
  };
});

var PresetSchedule = function PresetSchedule(_ref2) {
  var _ref2$open = _ref2.open,
      open = _ref2$open === void 0 ? false : _ref2$open,
      _ref2$anchorEl = _ref2.anchorEl,
      anchorEl = _ref2$anchorEl === void 0 ? null : _ref2$anchorEl,
      onSchedule = _ref2.onSchedule,
      onClose = _ref2.onClose;
  var classes = useStyles();
  var containerRef = (0, _react.useRef)(null);
  var trackGiftScheduled = (0, _userTrackGiftSchedule.useTrackGiftScheduled)();
  var handleSelectOption = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
    event.preventDefault();
    var _event$currentTarget$ = event.currentTarget.dataset,
        time = _event$currentTarget$.time,
        preset = _event$currentTarget$.preset;
    var momentTime = time ? (0, _momentTimezone.default)(time) : '';

    if (preset !== 'None') {
      trackGiftScheduled((0, _utils.toUnderscore)(preset), momentTime || null);
    }

    onSchedule(momentTime && momentTime.format());
  }, [onSchedule, trackGiftScheduled]);
  var handleClose = (0, _react.useCallback)(function (event) {
    if (containerRef.current && containerRef.current.contains(event.target) || anchorEl && anchorEl.contains(event.target)) {
      return;
    }

    onClose();
  }, [onClose, anchorEl]);
  return /*#__PURE__*/_react.default.createElement(_material.ClickAwayListener, {
    onClickAway: handleClose
  }, /*#__PURE__*/_react.default.createElement(_material.Popper, {
    className: classes.popper,
    open: open,
    anchorEl: anchorEl,
    placement: "top-end",
    modifiers: [{
      name: 'flip',
      enabled: true
    }, {
      name: 'preventOverflow',
      enabled: true,
      options: {
        altBoundary: true
      }
    }, {
      name: 'offset',
      options: {
        offset: '16px,4px'
      }
    }],
    role: undefined,
    transition: true,
    disablePortal: true
  }, function (_ref3) {
    var TransitionProps = _ref3.TransitionProps;
    return /*#__PURE__*/_react.default.createElement(_material.Zoom, (0, _extends2.default)({}, TransitionProps, {
      style: {
        transformOrigin: 'right bottom'
      }
    }), /*#__PURE__*/_react.default.createElement(_material.Paper, {
      ref: containerRef,
      className: classes.paper
    }, /*#__PURE__*/_react.default.createElement(_LocalizationProvider.default, {
      dateAdapter: _AdapterMoment.default
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      display: "flex",
      flexDirection: "column",
      pt: 3,
      pb: 1.5,
      px: 3
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: "H4-Chambray"
    }, "Schedule invite"), /*#__PURE__*/_react.default.createElement(_material.Box, {
      color: "grey.main",
      fontSize: "0.875rem"
    }, presetTimezone)), /*#__PURE__*/_react.default.createElement(_material.MenuList, {
      className: classes.menuList
    }, presets.map(function (_ref4) {
      var name = _ref4.name,
          time = _ref4.time;
      return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
        key: name,
        className: classes.menuItem,
        onClick: handleSelectOption,
        "data-preset": name,
        "data-time": time.format()
      }, /*#__PURE__*/_react.default.createElement(_material.Box, {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
      }, name, /*#__PURE__*/_react.default.createElement(_material.Box, {
        color: "grey.main",
        fontSize: "0.875rem"
      }, /*#__PURE__*/_react.default.createElement(_ui.DateFormat, {
        value: time,
        timezone: "US/Eastern",
        format: "MMM DD, hh:mm A"
      }))));
    }), /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      onClick: handleSelectOption,
      className: (0, _classnames.default)(classes.menuItem, classes.menuItemCustom),
      "data-preset": "None",
      "data-time": ""
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "calendar-alt",
      color: "inherit"
    }), /*#__PURE__*/_react.default.createElement(_material.Box, {
      ml: 1,
      display: "inline-block"
    }, "Pick Custom Date & Time")))))));
  }));
};

var _default = /*#__PURE__*/(0, _react.memo)(PresetSchedule);

exports.default = _default;